module.exports = __webpack_public_path__ + "img/31.e20a7762.jpg";